/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const E = /* @__PURE__ */ new Set(["children", "localName", "ref", "style", "className"]), m = /* @__PURE__ */ new WeakMap(), y = (t, a, u, i, f) => {
  const d = f == null ? void 0 : f[a];
  d === void 0 ? (t[a] = u, u == null && a in HTMLElement.prototype && t.removeAttribute(a)) : u !== i && ((l, c, o) => {
    let s = m.get(l);
    s === void 0 && m.set(l, s = /* @__PURE__ */ new Map());
    let n = s.get(c);
    o !== void 0 ? n === void 0 ? (s.set(c, n = { handleEvent: o }), l.addEventListener(c, n)) : n.handleEvent = o : n !== void 0 && (s.delete(c), l.removeEventListener(c, n));
  })(t, d, u);
}, h = ({ react: t, tagName: a, elementClass: u, events: i, displayName: f }) => {
  const d = new Set(Object.keys(i ?? {})), l = t.forwardRef((c, o) => {
    const s = t.useRef(/* @__PURE__ */ new Map()), n = t.useRef(null), p = {}, v = {};
    for (const [e, r] of Object.entries(c)) E.has(e) ? p[e === "className" ? "class" : e] = r : d.has(e) || e in u.prototype ? v[e] = r : p[e] = r;
    return t.useLayoutEffect(() => {
      if (n.current === null) return;
      const e = /* @__PURE__ */ new Map();
      for (const r in v) y(n.current, r, c[r], s.current.get(r), i), s.current.delete(r), e.set(r, c[r]);
      for (const [r, w] of s.current) y(n.current, r, void 0, w, i);
      s.current = e;
    }), t.useLayoutEffect(() => {
      var e;
      (e = n.current) == null || e.removeAttribute("defer-hydration");
    }, []), p.suppressHydrationWarning = !0, t.createElement(a, { ...p, ref: t.useCallback((e) => {
      n.current = e, typeof o == "function" ? o(e) : o !== null && (o.current = e);
    }, [o]) });
  });
  return l.displayName = f ?? u.name, l;
}, N = ({
  defineCustomElement: t,
  ...a
}) => (typeof t < "u" && t(), h(a));
export {
  N as createComponent
};
